import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import _ from 'lodash';

import { EXTERNAL_TASK_MANAGEMENT_TYPES } from 'src/app/constants';
import { ExternalTask } from 'src/models';
import { ApiService } from 'src/services/api.service';
import { AuthService } from 'src/services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-link-external-task-modal',
  templateUrl: './link-external-task-modal.component.html',
  styleUrls: ['./link-external-task-modal.component.scss'],
})
export class LinkExternalTaskModalComponent implements OnInit {
  @ViewChild('inputField') inputField;

  @Input()
  public externalTaskManagementConfig: any;

  public selectedExternalTaskId?: string;
  public externalTasks: ExternalTask[];
  public filteredExternalTasks: ExternalTask[];
  public isLoading: boolean;
  public isOpen = true;
  public searchText: string;
  public supportsSearch: boolean;
  public isGithub: boolean;
  public isMonday: boolean;
  public isAsana: boolean;
  public githubProjectName?: string;
  public githubProjects: any[] = [];
  public asanaProjects: any[] = [];
  public asanaProjectId?: string;
  public mondayBoardId?: string;
  public mondayBoards: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    private apiService: ApiService,
    private authService: AuthService,
  ) {}

  async ngOnInit() {
    const isAsana = this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.ASANA;
    const isHeight =
      this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.HEIGHT;
    const isLinear =
      this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.LINEAR;
    const isShortcut =
      this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.SHORTCUT;
    const isGithub =
      this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.GITHUB;
    const isMonday =
      this.authService.tenant.externalTaskManagementConfig?.type === EXTERNAL_TASK_MANAGEMENT_TYPES.MONDAY;

    this.supportsSearch = isLinear || isGithub || isShortcut || isHeight || isMonday || isAsana;
    this.isGithub = isGithub;
    this.isMonday = isMonday;
    this.isAsana = isAsana;

    if (isGithub) {
      this.githubProjects = await this.apiService.getPromise('/external-task-management/get-github-projects');
    }

    if (isMonday) {
      this.mondayBoards = await this.apiService.getPromise('/external-task-management/get-monday-boards');
    }

    if (isAsana) {
      this.asanaProjects = await this.apiService.getPromise('/external-task-management/get-asana-projects');
    }

    if (!isGithub && !isMonday && !isAsana) {
      await this.loadExternalTasks();
    }
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.inputField.setFocus();
    }, 100);
  }

  async loadExternalTasks() {
    this.isLoading = true;

    const options: any = {
      query: this.searchText,
      providerConfig: {
        githubProjectName: this.githubProjectName,
        mondayBoardId: this.mondayBoardId,
        asanaProjectId: this.asanaProjectId,
      },
    };

    const externalTasksResult: any = await this.apiService.postPromise('/external-task-management/search', options);

    this.externalTasks = externalTasksResult;
    this.isLoading = false;
  }

  dismiss() {
    this.isOpen = false;
    this.modalCtrl.dismiss();
  }

  async selectExternalTask(externalTaskId: string) {
    this.selectedExternalTaskId = externalTaskId;

    this.isOpen = false;

    this.modalCtrl.dismiss({
      externalTaskId: this.selectedExternalTaskId,
      providerConfig: {
        githubProjectName: this.githubProjectName,
        mondayBoardId: this.mondayBoardId,
        asanaProjectId: this.asanaProjectId,
      },
    });
  }

  handleFilters() {
    this.loadExternalTasks();
  }
}
